import React, { useState } from "react";
import { Spinner } from "reactstrap";

const PaymentActions = ({ row, onUpdate }) => {
  const [loading, setLoading] = useState(null); // "approved" | "rejected"

  const handleClick = async (status) => {
    setLoading(status);
    try {
      await onUpdate(row.id, status);
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="d-flex gap-2">
      <button
        className="btn btn-primary"
        onClick={() => handleClick("approved")}
        disabled={loading !== null ||row.status ==="approved" ||row.status ==="rejected"} 
      >
        {loading === "approved" ? <Spinner size="sm" /> : "قبول"}
      </button>

      <button
        className="btn btn-danger"
        onClick={() => handleClick("rejected")}
        disabled={loading !== null}
            disabled={loading !== null ||row.status ==="approved" ||row.status ==="rejected"} 
      >
        {loading === "rejected" ? <Spinner size="sm" /> : "رفض"}
      </button>
    </div>
  );
};

export default PaymentActions;